/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type infoResetPasswordInput = {
    clientMutationId?: string | null;
    token: string;
    newPassword: string;
    confirmPassword: string;
};
export type ResetPasswordFormMutationVariables = {
    input: infoResetPasswordInput;
};
export type ResetPasswordFormMutationResponse = {
    readonly infoResetPassword: {
        readonly clientMutationId: string | null;
    } | null;
};
export type ResetPasswordFormMutation = {
    readonly response: ResetPasswordFormMutationResponse;
    readonly variables: ResetPasswordFormMutationVariables;
};



/*
mutation ResetPasswordFormMutation(
  $input: infoResetPasswordInput!
) {
  infoResetPassword(input: $input) {
    clientMutationId
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "infoResetPasswordPayload",
    "kind": "LinkedField",
    "name": "infoResetPassword",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ResetPasswordFormMutation",
    "selections": (v1/*: any*/),
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ResetPasswordFormMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "841e5094099305e1a6f34188418f906b",
    "id": null,
    "metadata": {},
    "name": "ResetPasswordFormMutation",
    "operationKind": "mutation",
    "text": "mutation ResetPasswordFormMutation(\n  $input: infoResetPasswordInput!\n) {\n  infoResetPassword(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
(node as any).hash = '11be63985f48386248a92467e05ff2da';
export default node;
